import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';

const useRidesListingCMSData = () => {
  const { t } = useTranslation();

  const data = useMemo(
    () => ({
      data: {
        RidesListingPage: {
          heroBackground: {
            small_url: {
              url: '/imgs/Rebranding/rides/ride-hero-sm.jpg',
            },
            medium_url: {
              url: '/imgs/Rebranding/rides/ride-hero-md.jpg',
            },
            large_url: {
              url: '/imgs/Rebranding/rides/ride-hero-lg.jpg',
            },
            xlarge_url: {
              url: '/imgs/Rebranding/rides/ride-hero-xl.jpg',
            },
            alt: 'Ride Page Background',
          },
          patternBackground: {
            small_url: {
              url: '/imgs/Rebranding/petterns/asphalt_sm.png',
            },
            medium_url: {
              url: '/imgs/Rebranding/petterns/asphalt_sm.png',
            },
            large_url: {
              url: '/imgs/Rebranding/petterns/asphalt.png',
            },
            xlarge_url: {
              url: '/imgs/Rebranding/petterns/asphalt.png',
            },
            alt: 'pattern Background',
          },
          motorcycleRides: t('rides_listing:motorcycle_rides'),
          motorcycleRidesForLocation: t('rides_listing:location_attractions'),
          allLocationsLabel: t('rides_listing:all_locations'),
          heroSubtitle: t('rides_listing:sub_title'),
        },
        EventRideCardComponent: {
          featuredLabel: t('common_event_ride_card:featured'),
          learnMoreBtnLabel: t('common_event_ride_card:learn_more'),
        },
      },
    }),
    [t],
  );

  return data;
};

export { useRidesListingCMSData };